// language=GraphQL
export const ALL_EXTENSIONS_QUERY = `query Query($withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {
  extensions: ratioTravelExtensions {
    id
    label
    info
    travelExtension @include(if: $withTravelExtension) {
      id
      duration
      name
      description
      highlights @include(if: $withTravelExtensionHighlights) {
        id
        text
      }
      image @include(if: $withTravelExtensionImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    accommodationMapItems @include(if: $withAccommodationMapItems) {
      id
      baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_EXTENSION_QUERY = `query Query($id: ID!, $withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {
  extension: ratioTravelExtension(id: $id) {
    id
    label
    info
    travelExtension @include(if: $withTravelExtension) {
      id
      duration
      name
      description
      highlights @include(if: $withTravelExtensionHighlights) {
        id
        text
      }
      image @include(if: $withTravelExtensionImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    accommodationMapItems @include(if: $withAccommodationMapItems) {
      id
      baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
    }
  }
}`

// language=GraphQL
export const CREATE_EXTENSION_MUTATION = `
  mutation Mutation($input: CreateRatioTravelExtensionInput, $withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {
    extension: createRatioTravelExtension(input: $input) {
      id
      label
      info
      travelExtension @include(if: $withTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_EXTENSION_MUTATION = `
  mutation Mutation($input: UpdateRatioTravelExtensionInput, $withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {
    extension: updateRatioTravelExtension(input: $input) {
      id
      label
      info
      travelExtension @include(if: $withTravelExtension) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelExtensionHighlights) {
          id
          text
        }
        image @include(if: $withTravelExtensionImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      accommodationMapItems @include(if: $withAccommodationMapItems) {
        id
        baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_EXTENSION_MUTATION = `
  mutation Mutation($input: DeleteRatioTravelExtensionInput) {
    deleteRatioTravelExtension(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_EXTENSION_MUTATION = `
  mutation Mutation($input: DeleteRatioTravelExtensionInput) {
    forceDeleteRatioTravelExtension(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = `
  mutation Mutation($input: addRatioTravelExtensionAccommodationMapItemsInput) {
    addRatioTravelExtensionAccommodationMapItems(input: $input) {
      id
      accommodationMapItemIds
    }
  }`

// language=GraphQL
export const REMOVE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = `
  mutation Mutation($input: removeRatioTravelExtensionAccommodationMapItemsInput) {
    removeRatioTravelExtensionAccommodationMapItems(input: $input) {
      id
      accommodationMapItemIds
    }
  }`

// language=GraphQL
export const CREATE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = `
  mutation Mutation($input: createRatioTravelExtensionAccommodationMapItemsInput) {
    createRatioTravelExtensionAccommodationMapItems(input: $input) {
      id
      accommodationMapItemIds
    }
  }`

// language=GraphQL
export const DELETE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = `
  mutation Mutation($input: deleteRatioTravelExtensionAccommodationMapItemsInput) {
    deleteRatioTravelExtensionAccommodationMapItems(input: $input) {
      id
      accommodationMapItemIds
    }
  }`

// language=GraphQL
export const EXTENSIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravelDates: Boolean = false, $withRatioTravels: Boolean = false, $withTravellers: Boolean = false) {
  groupedDependents: ratioTravelExtensionDependents(id: $id) {
    ratioTravelDates @include(if: $withRatioTravelDates) {
      id
      dateNo
      startDate
      endDate
      includesExtension
      json
    }
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
  }
}`
